import { LazyLoadImage } from 'react-lazy-load-image-component';
import { shouldOpenInNewTab } from '@Components/Utilities/SandhillsUtility';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper'; 
import translator from '@Components/Utilities/Translator';

const CategoryIconGrid = ({ categories, isMobile, hpcColumnOverride, useH3 }) => {
    const getCategoryGrid = (filteredCategories) => {
        return filteredCategories.map((category, index) => {
            const HeadingTag = useH3 ? 'h3' : 'h2';
            return (<div key={'category-' + (isMobile ? 'mobile' : 'desktop') + '-' + (index)} className={'category ' + (category.HasChildren ? ' parent-category ' : ' ') + (hpcColumnOverride ? hpcColumnOverride : '')} category-id={category.CategoryId}>
                <HeadingTag>
                    <a href={category.sRouteURL} target={shouldOpenInNewTab(category.sRouteURL) ? '_blank' : '_self'} className='category-content'>
                        <div className="content-icon">
                            <LazyLoadImage src={category.sImageURL} className={category.CSSClass} alt={category.AltText.replace("{0}", category.Name)} title={category.Name} />
                        </div>
                        <span dangerouslySetInnerHTML={{ __html: category.Name }}></span>
                        {shouldOpenInNewTab(category.sRouteURL) && <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>}
                    </a>
                </HeadingTag>
            </div>);
        });
    };

    const getSubGroupedCategoryGrid = () => {
        var subGroups = getDistinct(categories.map(cat => cat.SubGroupName));

        return subGroups.map((group, index) => {
            var filteredCategories = categories.filter(cat => { return cat.SubGroupName === group });

            return (
                isMobile
                    ?
                    <Accordion className="category-icon-accordion">
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel-${group}-content`} id={`panel-${group}-header`} className="accordion-header">
                            {group}
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                            {getCategoryGrid(filteredCategories)}
                        </AccordionDetails>
                    </Accordion>
                    :
                    <>
                        <div className='category-icons' key={'subGroup-' + index}>
                            {group && <h2 className='subgroup-heading'>{group}</h2>}
                            {getCategoryGrid(filteredCategories)}
                        </div>
                    </>
            );
        });
    };

    const getDistinct = (arr) => {
        return arr.filter((val, index, self) => self.indexOf(val) === index);
    };

    const getApplicableGrid = () => {
        if (categories.filter(cat => cat.SubGroupName).length > 0) {
            return getSubGroupedCategoryGrid();
        }
        else if (isMobile && categories.filter(cat => cat.BaseCatIDForMobileColumns).length > 0) {
            var baseCats = getDistinct(categories.map(cat => cat.BaseCatIDForMobileColumns));

            return baseCats.map((baseCatID, index) => {
                var groupedCategories = categories.filter(cat => { return cat.BaseCatIDForMobileColumns === baseCatID });

                return (
                    <div className='base-category-group' key={'baseCatGroup-' + index}>
                        {getCategoryGrid(groupedCategories)}
                    </div>);
            });
        }

        return getCategoryGrid(categories);
    };

    return (
        <>
            {getApplicableGrid()}
        </>
    );
};

export default CategoryIconGrid;